module.exports = __webpack_public_path__ + "static/img/consumed-one.fd3dbc93.png";